import React, { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import anime from "animejs/lib/anime.es.js";
import Loader from "react-js-loader";
import { formatDate } from "../../utils/formateDate";
import { ApiHook } from "../../hooks/apiHook";
import { updateSponserTree } from "../../store/reducers/treeReducer";

const BoardTreeNode = (props) => {
  const { t } = useTranslation();
  const NoProfile = "/images/user-profile.png";
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(true);
  const [hoveredItemId, setHoveredItemId] = useState([]);
 
  const [showPopover, setShowPopover] = useState(false);
  const [copied, setCopied] = useState(false);
  const listRef = useRef(null);
//   const updatedTreeMutation = ApiHook.CallSponserTreeMore();
//   const setSelectedUserId = props.setSelectedUserId;
//   const setDoubleClickedUser = props.setDoubleClickedUser;

  let singleClickTimer = null;
//   const HandleClick = (data, event) => {
//     clearTimeout(singleClickTimer); // Clear any existing single-click timer

//     if (event.detail === 2) {
//       // Double-click detected
//       setSelectedUserId("");
//       setDoubleClickedUser(data?.attributes?.id);
//     } else {
//       // Single-click logic
//       singleClickTimer = setTimeout(() => {
//         if (data?.children.length === 0 && data?.attributes.childrenCount > 0) {
//           setDoubleClickedUser("");
//           setSelectedUserId(data?.attributes?.id);
//         } else {
//           setExpanded(!expanded);
//         }
//         clearTimeout(singleClickTimer); // Clear the timer after executing the single-click logic
//       }, 200); // Adjust the time according to your needs
//     }
//   };

  const handleItemHover = (itemId) => {
    setHoveredItemId(itemId);
  };

//   const handleIsMore = (data) => {
//     updatedTreeMutation.mutateAsync(data, {
//       onSuccess: (res) => {
//         if (res.status) {
//             dispatch(
//                 updateSponserTree({
//                     fatherId: data?.fatherId,
//                     position: data?.position,
//                     newChildren: res?.data
//                 })
//             )
//         }
//     },
//     });
//   };

  const handlePopoverClick = (e) => {
    e.stopPropagation();
  };
  const handlePopoverDoubleClick = (e) => {
    e.stopPropagation();
  };
  const copyToClipboard = async (text) => {
    if (navigator && navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        // Reset copied status after a delay (e.g., 2 seconds)
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      } catch (error) {
        console.error("Clipboard copy failed:", error);
      }
    } else {
      // Clipboard API is not supported, provide a fallback method
      try {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        setCopied(true);
        // Reset copied status after a delay (e.g., 2 seconds)
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      } catch (error) {
        console.error("Fallback clipboard copy failed:", error);
      }
    }
  };
  const handleMouseLeave = (e) => {
    const relatedTarget = e.relatedTarget;
    const currentTarget = e.currentTarget;
  
    if (relatedTarget instanceof Node && currentTarget instanceof Node) {
      const isMouseOutsidePopover = !relatedTarget || !currentTarget.contains(relatedTarget);
  
      if (isMouseOutsidePopover) {
        setShowPopover(false);
      }
    }else{
      setShowPopover(false);
    }
  };
  const handleMouseEnterPopover = () => {
    setShowPopover(true);
  };
  const handleMouseLeavePopover = () => {
    // Uncomment this line if you want to hide the popover when mouse leaves the popover content
    setShowPopover(false);
  };

  useEffect(() => {
    if (expanded) {
      anime({
        targets: listRef.current,
        translateY: [`${-20}px`, `${0}px`],
        opacity: [0, 1],
        duration: 500,
        easing: "easeInQuad",
      });
    }
  }, [expanded]);
  const renderPopover = (content) => (
    <Popover>
      <Popover.Body>{`${content}`}</Popover.Body>
    </Popover>
  );
  const popover = (
    <Popover
      id="popover"
      onClick={handlePopoverClick}
      onDoubleClick={handlePopoverDoubleClick}
      onMouseEnter={handleMouseEnterPopover}
      onMouseLeave={handleMouseLeavePopover}
    >
      <div id="treeview_pop">
        <div className="card">
          <div className="card-img-top">
            <div className="card-img-top_img">
              <img
                src={
                  hoveredItemId?.tooltipData?.profilePic
                    ? hoveredItemId?.tooltipData?.profilePic
                    : NoProfile
                }
                alt="profile_photo"
              />
            </div>
            <h5 className="card-title">
              {hoveredItemId?.tooltipData?.username}
              <OverlayTrigger
                trigger={["hover", "focus"]}
                placement="top"
                overlay={renderPopover(copied ? "Copied" : t("copyUsername"))}
              >
                <span
                  onClick={() =>
                    copyToClipboard(hoveredItemId?.tooltipData?.username)
                  }
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    height="1em"
                    width="1em"
                  >
                    <path d="M19 21H8V7h11m0-2H8a2 2 0 00-2 2v14a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2m-3-4H4a2 2 0 00-2 2v14h2V3h12V1z" />
                  </svg>
                </span>
              </OverlayTrigger>
            </h5>
            <p className="card-text">
              {hoveredItemId?.tooltipData?.fullName
                ? hoveredItemId?.tooltipData?.fullName
                : "username"}
            </p>
          </div>
          <div className="card-body">
            <div className="user_detail_tabl">
              <table>
                <tbody>
                  {hoveredItemId?.tooltipData?.tableData &&
                    Object.entries(hoveredItemId.tooltipData.tableData).map(
                      ([key, value]) => (
                        <tr key={key}>
                          <td>{key}</td>
                          <td>
                            {key === "joinDate" ? formatDate(value) : value}
                          </td>
                        </tr>
                      )
                    )}
                </tbody>
              </table>
            </div>
            {hoveredItemId?.tooltipData?.rankDetails &&
              hoveredItemId?.tooltipData?.rankDetails?.name && (
                <a
                  className="btn btn-rank"
                  style={{
                    backgroundColor:
                      hoveredItemId?.tooltipData?.rankDetails?.color,
                  }}
                >
                  {hoveredItemId?.tooltipData?.rankDetails?.name}
                </a>
              )}
          </div>
        </div>
      </div>
    </Popover>
  );
  return (
    <li>
      {props.data?.isPlaceholder ? (
        <>
          {/* <a>
            <div className="member-view-box">
              <div className="member-image">
                {props?.data?.isMore && (
                  <>
                    {updatedTreeMutation.status === "loading" ? (
                      <>
                        <Loader
                          type="spinner-default"
                          bgColor={"#954cea"}
                          color={"#954cea"}
                          size={25}
                        />
                      </>
                    ) : (
                      <>
                        <div
                          className="right_more_user_expand_btn"
                          onClick={() => handleIsMore(props?.data?.attributes)}
                        >
                          <i className="fas fa-angle-double-right"></i>
                        </div>
                        <div className="member-details-dwnl-bx">
                          {props?.data?.attributes?.moreChildren} {t("more")}
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </a> */}
        </>
      ) : (
        <>
          {props?.data?.children?.length === 0 &&
          props?.data?.attributes?.id === props?.selectedUserId ? (
            <div className="member-view-box">
              <div className="member-image">
                <Loader
                  type="spinner-default"
                  bgColor={"#f15623"}
                  color={"#f15623"}
                  size={25}
                />
              </div>
            </div>
          ) : (
            <a
            //   onClick={(e) => HandleClick(props.data, e)}
              onMouseEnter={() => handleItemHover(props.data)}
              onMouseLeave={() => handleItemHover([])}
            >
              <div className="member-view-box">
                <OverlayTrigger
                  trigger="manual"
                  placement="bottom"
                  overlay={popover}
                  show={showPopover}
                  onMouseEnter={handleMouseEnterPopover}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="member-image">
                    <img
                      src={
                        props.data?.attributes?.treeIcon === null ||
                        props.data?.attributes?.treeIcon === ""
                          ? NoProfile
                          : props.data?.attributes?.treeIcon
                      }
                      alt="Member"
                      onMouseEnter={() => setShowPopover(true)}
                      onMouseLeave={handleMouseLeave}
                    />
                    <div className="member-details">
                      <h3>{props.data?.username}</h3>
                      <div className="member-details-downline-dtl">
                        <div className="member-details-dwnl-bx">
                          {/* {t("count")}:{" "} */}
                          <strong>
                            {/* {props.data?.attributes?.childrenCount} */}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </OverlayTrigger>
              </div>
            </a>
          )}
          {props.data?.children?.length > 0 && expanded && (
            <ul ref={listRef}>
              {props.data?.children?.map((child, index) => {
                return (
                  <BoardTreeNode
                    key={index}
                    data={child}
                    plan={props.plan}
                    // selectedUserId={props.selectedUserId}
                    // setSelectedUserId={props.setSelectedUserId}
                    // doubleClickedUser={props.doubleClickedUser}
                    // setDoubleClickedUser={props.setDoubleClickedUser}
                  />
                );
              })}
            </ul>
          )}
        </>
      )}
    </li>
  );
};
const BoardTreeComponent = (props) => {
  const mlmPlan = useSelector(
    (state) => state.user?.loginResponse?.moduleStatus?.mlm_plan
  );
  const data = useSelector((state) => state.tree?.boardTreeList);
  return (
    <BoardTreeNode
      data={data}
      plan={mlmPlan}
    //   selectedUserId={props.selectedUserId}
    //   setSelectedUserId={props.setSelectedUserId}
    //   doubleClickedUser={props.doubleClickedUser}
    //   setDoubleClickedUser={props.setDoubleClickedUser}
    />
  );
};
export default BoardTreeComponent;